"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomAttributeFilters = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sdk = require("../../../sdk");
var _FieldWrapper = require("../FieldWrapper");
var _IssueCustomAttributeTextFilter = require("../IssueCustomAttributeTextFilter/IssueCustomAttributeTextFilter");
var _CustomFieldMultiSelectDropdown = require("../CustomFieldMultiSelectDropdown");
var _issueCustomFields = require("../../state/redux/ducks/issueCustomFields");
var _issueCustomFieldMappings = require("../../state/redux/ducks/issueCustomFieldMappings");
var _hooks = require("../../state/redux/hooks");
var _consts = require("../../utils/styles/consts");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _IssueCustomListMultiSelectDropdown = require("../IssueCustomListMultiSelectDropdown.tsx");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const isListCustomField = customField => customField.dataType === _sdk.IssueCustomAttributeType.List;
const CustomAttributeFilters = _ref => {
  let {
    filter,
    handleFilterChange,
    container,
    ...props
  } = _ref;
  const [selectedCustomFieldIds, setSelectedCustomFieldIds] = (0, _react.useState)(filter ? Object.keys(filter) : []);
  const mappedCustomAttributeIdSet = (0, _hooks.useSelector)(_issueCustomFieldMappings.getMappedCustomAttributeIdSet);
  const customFields = (0, _hooks.useSelector)(_issueCustomFields.getOrderedCustomFields).filter(field => mappedCustomAttributeIdSet.has(field.id));
  const customFieldEntitiesMap = (0, _hooks.useSelector)(_issueCustomFields.getCustomFieldEntitiesMap);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const handleCustomFieldFilterChange = (id, value) => {
    const customAttributeFilter = {
      ...filter
    };
    if (!!value) {
      customAttributeFilter[id] = value;
    } else {
      delete customAttributeFilter[id];
    }
    handleFilterChange({
      customAttributes: Object.entries(customAttributeFilter).length === 0 ? undefined : customAttributeFilter
    });
  };
  return customFields.length ? /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.customFields"),
    style: {
      paddingTop: 32
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      ..._consts.FIELD_WRAPPER_FONT,
      paddingBottom: 6
    }
  }, T.translate("filterPanel.selectCustomFieldFilters")), /*#__PURE__*/_react.default.createElement(_CustomFieldMultiSelectDropdown.CustomFieldMultiSelectDropdown, _extends({
    selectedCustomFieldIds: selectedCustomFieldIds,
    customFields: customFields,
    onChange: selectedIds => {
      setSelectedCustomFieldIds(selectedIds);
      if (selectedIds.length === 0) {
        handleFilterChange({
          customAttributes: undefined
        });
        return;
      }
      for (const id of mappedCustomAttributeIdSet.keys()) {
        // remove any filter that had a value and was unselected
        if (!selectedIds.includes(id) && filter && !!filter[id]) {
          handleCustomFieldFilterChange(id, null);
        }
      }
    },
    container: container,
    "data-testid": "custom-attribute-filter-multi-select-dropdown"
  }, props)), selectedCustomFieldIds.map(id => {
    const customField = customFieldEntitiesMap[id];
    const value = filter ? filter[id] : undefined;

    // When we pass the children from FieldWrapper to FormField here, we use an object and apply [customField.dataType] to it.
    // We don't use a function with switch/case because the function wouldn't end up returning the component
    return !!customField ? /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
      key: id,
      label: customField.title
    }, isListCustomField(customField) ? /*#__PURE__*/_react.default.createElement(_IssueCustomListMultiSelectDropdown.IssueCustomListMultiSelectDropdown, {
      container: container,
      attribute: customField,
      value: value,
      onChange: selectedValue => handleCustomFieldFilterChange(id, selectedValue),
      "data-testid": "Filter__".concat(customField.dataType, "-").concat(id)
    }) : /*#__PURE__*/_react.default.createElement(_IssueCustomAttributeTextFilter.IssueCustomAttributeTextFilter, {
      value: value,
      dataType: customField.dataType,
      onChange: text => handleCustomFieldFilterChange(id, text),
      dataTestId: "Filter__".concat(customField.dataType, "-").concat(id)
    })) : null;
  })) : null;
};
exports.CustomAttributeFilters = CustomAttributeFilters;
//# sourceMappingURL=CustomAttributeFilters.js.map